export var Text = {
    type: 'object',
    properties: {
        content: {
            type: 'string',
            'x-decorator': 'FormItem',
            'x-component': 'Input.TextArea',
        },
        mode: {
            type: 'string',
            'x-decorator': 'FormItem',
            'x-component': 'Select',
            'x-component-props': {
                defaultValue: 'normal',
            },
            enum: ['h1', 'h2', 'h3', 'p', 'normal'],
        },
    },
};
